/* eslint-disable no-use-before-define */
import React from 'react'

export const ChartCaption = ({chartData, bondInfo}) =>
    <table>
        <thead>
            <tr>
                <th>Price</th>
                <th>Yield to Maturity</th>
                {bondInfo.isCallable && <th>Yield to Call</th>}
            </tr>
        </thead>
    <tbody>
        {chartData
        .map(({price, ytm, ytc}, i) =>
            <tr key={i}>
                <td>{price}</td>
                <td>{ytm}</td>
                {bondInfo.isCallable && <td>{ytc}</td>}
            </tr>)}
    </tbody>
    </table>